import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getPrizeById, patchPrizeWheel, postPrizeWheel, postPrizeWheelTranslation } from "../thunks";

import { IFormPrizeCreate } from "../../../entities/wheelGame";
import { getWheelEntity, patchWheelEntity, postWheelEntity, postWheelEntityTranslate } from "./thunks";

interface WheelState {
  loading: boolean,
  published: boolean,
  saveLoading: boolean,
  errorPrize?: string,
  gameEntity?: IFormPrizeCreate
}

const initialState: WheelState = {
  loading: false,
  published: false,
  saveLoading: false,
}

const addLoadingCases = (
  builder: ActionReducerMapBuilder<WheelState>,
  action: any
) => {
  builder.addCase(action.pending, (state: WheelState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: WheelState) => {
    state.saveLoading = false;
  });
};

export const wheelSlice = createSlice({
  name: "wheelEntity",
  initialState,
  reducers: {
    clearPrizeState: (state) => {
      state.gameEntity = undefined;
      state.errorPrize = undefined;
      state.published = false;
    },
    addedErrorPrizeState: (state, action: PayloadAction<string>) => {
      state.errorPrize = action.payload;
    },
    clearErrorPrizeState: (state) => {
      state.errorPrize = undefined;

    }
  },
  extraReducers: (builder) => {
    // getPrizeById
    builder.addCase(getPrizeById.pending, (state) => {
      state.loading = true;
      state.errorPrize = undefined;
      state.gameEntity = undefined;
    })
    builder.addCase(getPrizeById.fulfilled, (state, action) => {
      if (action.payload) {
        const { translations, name, bonusId, config, langs, id, published } = action.payload;
        state.gameEntity = {
          id: id,
          name: name,
          bonusId: bonusId.toString(),
          jackpot: `${config.jackpot}`,
          language: langs,
          translations: translations,
        }
        state.published = published;
      }
      state.loading = false;
    })
    // getWheelEntity
    builder.addCase(getWheelEntity.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(getWheelEntity.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload
        const modifaiteBody = {
          id: data.id,
          name: data.name,
          bonusId: `${data.bonus.id}`,
          jackpot: `${data.config.jackpot}` as 'true' | 'false',
          language: data.langs,
          translations: data.translations ? data.translations.map((item) => ({
            id: item.id,
            lang: item.lang,
            config: {
              imageFile: item.segmentImage,
              prizeFile: item.prizeImage,
            }
          })) : [],
        }
        state.gameEntity = modifaiteBody;
        state.published = data.isPublished;
      }
      state.loading = false;
    })
    // postWheelEntity
    builder.addCase(postWheelEntity.pending, (state) => {
      state.saveLoading = true;

    })
    builder.addCase(postWheelEntity.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload
        const modifaiteBody = {
          id: data.id,
          name: data.name,
          bonusId: `${data.bonus.id}`,
          jackpot: `${data.config.jackpot}` as 'true' | 'false',
          language: data.langs,
          translations: data.translations ? data.translations.map((item) => ({
            id: item.id,
            lang: item.lang,
            config: {
              imageFile: item.segmentImage,
              prizeFile: item.prizeImage,
            }
          })) : [],
        }
        state.gameEntity = modifaiteBody;
        state.published = data.isPublished;
      }
      state.saveLoading = false;
    })
    // patchWheelEntity
    builder.addCase(patchWheelEntity.pending, (state) => {
      state.saveLoading = true;

    })
    builder.addCase(patchWheelEntity.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload
        const modifaiteBody = {
          id: data.id,
          name: data.name,
          bonusId: `${data.bonus.id}`,
          jackpot: `${data.config.jackpot}` as 'true' | 'false',
          language: data.langs,
          translations: data.translations ? data.translations.map((item) => ({
            id: item.id,
            lang: item.lang,
            config: {
              imageFile: item.segmentImage,
              prizeFile: item.prizeImage,
            }
          })) : [],
        }
        state.gameEntity = modifaiteBody;
        state.published = data.isPublished;
      }
      state.saveLoading = false;
    })

    const saveActions = [
      postPrizeWheel,
      patchPrizeWheel,
      postPrizeWheelTranslation,
      postWheelEntityTranslate
    ];
    saveActions.forEach((action) => addLoadingCases(builder, action));
  },
});

export const { clearPrizeState, clearErrorPrizeState, addedErrorPrizeState } = wheelSlice.actions;

// export const selectModifierBonus = (state: RootState) => state.bonus.modifier;

export default wheelSlice.reducer;
